import { lazy } from 'react';

import type { ModuleWeb } from '../modules/registry.js';
import './aide.css';

/**
 * Aide intégrée (documentation dynamique) : composant isolé de la coque. Deux points
 * d'entrée seulement : `aideWeb` (routes, dans le registre des écrans) et `AideBouton`
 * (bouton de l'en-tête et touche `?`, passé à la coque par App.tsx).
 */

const CentreAidePage = lazy(() =>
  import('./CentreAide.js').then((m) => ({ default: m.CentreAidePage })),
);
const PageAide = lazy(() => import('./CentreAide.js').then((m) => ({ default: m.PageAide })));
const NouveautesPage = lazy(() =>
  import('./Nouveautes.js').then((m) => ({ default: m.NouveautesPage })),
);
const DocumentationPage = lazy(() =>
  import('./Documentation.js').then((m) => ({ default: m.DocumentationPage })),
);

export const aideWeb: ModuleWeb = {
  module: 'socle',
  routes: [
    { path: '/aide', element: <CentreAidePage /> },
    { path: '/aide/nouveautes', element: <NouveautesPage /> },
    { path: '/aide/:module/:page', element: <PageAide /> },
    { path: '/administration/documentation', element: <DocumentationPage /> },
  ],
};

export { AideBouton } from './AidePanneau.js';
